import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"
import useSortData from './useSortData';
import useDelete from './useDelete';

export default function useMasses(props, emit, massData) {

    // Get toast interface
    const toast = useToast()
    const date = ref("")
    const perPage = ref(10)
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getMasses = (url = null) => {
        store.dispatch("getMasses", {
            url,
            date: date.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true
        if (massData.value.id) {
            store.dispatch('updateMass', massData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("آیین قربانی با موفقیت به روز شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getMasses")
                        closeModal()
                    }
                })

        } else {
            store
                .dispatch("createMass", massData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        console.log('Yes');
                        toast.success("آیین قربانی مورد نظر با موفقیت اضافه شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getMasses")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }

    const { sortField, sortDirection, sortData } = useSortData(getMasses);

    const sortMasses = (field) => {
        sortData(field);
        getMasses();
    };

    const deleteMass = (mass) => {
        const { confirmDelete } = useDelete(
            () => store.dispatch("deleteMass", mass),
            'آیین قربانی مورد نظر حذف شد.',
            getMasses
        );

        confirmDelete();
    };


    return {
        show,
        date,
        perPage,
        sortField,
        sortDirection,
        loading,
        errors,
        getMasses,
        onSubmit,
        closeModal,
        sortMasses,
        deleteMass,
    }
}